export default __webpack_public_path__ + "static/media/chi4.5041c123.jpg";